module.exports = __webpack_public_path__ + "img/MyTrip.9e133120.svg";